import { Row, Col, Breadcrumb } from "react-bootstrap";
import { ILicenseeReturnDetails } from "../../../api/ILicenseeReturns";
import { ILicenceProfile } from "../../../api/LicenceProfile";

interface BreadcrumbProps {
  licenceProfile: ILicenceProfile;
  licenseeReturn: ILicenseeReturnDetails;
}

const BreadCrumbs = ({ licenceProfile, licenseeReturn }: BreadcrumbProps) => (
  <Row>
    <Col xs="12">
      <Breadcrumb className="leap">
        <Breadcrumb.Item href="/">LEAP Online Home</Breadcrumb.Item>
        <Breadcrumb.Item href={`/licence-profile/${licenceProfile.profileNo}`}>
          {licenceProfile.organisation} - {licenceProfile.profileNo}
        </Breadcrumb.Item>
        <Breadcrumb.Item
          href={`/licence-profile/${licenceProfile.profileNo}/compliance`}
        >
          Compliance
        </Breadcrumb.Item>
        <Breadcrumb.Item active>{licenseeReturn.reference}</Breadcrumb.Item>
      </Breadcrumb>
    </Col>
  </Row>
);

export default BreadCrumbs;
